module.exports = __webpack_public_path__ + "img/vignettes-asso_0003_compagnie-labyrinthe.6980e67b.jpg";